module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_9005.2ff19319.png";